<div class="item-list-component terms-and-conditions"></div>

<accept-terms-and-conditions-component #accept></accept-terms-and-conditions-component>
